import { BaseDto } from '../base.dto';
import { MerchantDto } from '../merchant.dto';
import { StockDto } from '../stock.dto';
import { AclStockPermissionListDto } from '../acl-stock-permission-list';

export class AclStockPermissionDto extends BaseDto {
  sourceMerchantId: number;
  targetMerchantId: number;
  stockEntityId: number;
  supplierEntityId: number;
  stockPermissionListId: number;
  sourceMerchant?: MerchantDto;
  targetMerchant?: MerchantDto;
  stockEntity?: StockDto;
  stockPermissionList?: AclStockPermissionListDto;
}
